/**
 * Copertine naturalistiche dei Monti della Laga — archivio locale + Commons CC BY-SA.
 * Non usare stock generici al posto di questi file.
 */
export const LAGA_BOSCHI_SENTIERO =
  "/api/uploads/laga/laga_boschi_sentiero.jpg";
export const LAGA_CASCATA_MORRICANA =
  "/api/uploads/laga/laga_cascata_morricana.jpg";
export const LAGA_VALLE_CENTO_CASCATE =
  "/api/uploads/laga/laga_valle_cento_cascate.jpg";
export const LAGA_VALLE_CENTO_FOSSO =
  "/api/uploads/laga/laga_valle_cento_cascate_fosso.jpg";
export const LAGA_FOLTRONE_VETTA = "/api/uploads/campli/monte-foltrone-vetta.png";
export const LAGA_FOLTRONE_PANORAMA = "/api/uploads/campli/monte-foltrone-panorama.png";

export const LAGA_CENTO_CASCATE_ARCHIVE = [
  LAGA_VALLE_CENTO_CASCATE,
  LAGA_VALLE_CENTO_FOSSO,
  "/api/uploads/crognaleto/monumento-valle-delle-cento-cascate-01-dscn7969-copia.jpg",
  "/api/uploads/crognaleto/monumento-valle-delle-cento-cascate-03-dscn8002.jpg",
  "/api/uploads/crognaleto/monumento-valle-delle-cento-cascate-04-dscn8028.jpg",
  "/api/uploads/crognaleto/monumento-valle-delle-cento-cascate-05-dscn8046.jpg",
  "/api/uploads/crognaleto/monumento-valle-delle-cento-cascate-06-lda-1825-1.jpg",
];

export const LAGA_BOSCHI_GALLERY = [
  LAGA_BOSCHI_SENTIERO,
  "/api/uploads/crognaleto/frazione-san-giorgio-18-veduta-dal-sentiero-verso-la-cava.jpg",
  "/api/uploads/crognaleto/frazione-senarica-14-senarica-bosco.jpg",
];

export const LAGA_MORRICANA_GALLERY = [
  LAGA_CASCATA_MORRICANA,
  LAGA_BOSCHI_SENTIERO,
];

export const LAGA_FOLTRONE_GALLERY = [
  LAGA_FOLTRONE_VETTA,
  LAGA_FOLTRONE_PANORAMA,
  LAGA_BOSCHI_SENTIERO,
];

/** Credito obbligatorio CC BY-SA 3.0 per la copertina Morricana. */
export const LAGA_MORRICANA_CREDIT =
  "Cascata della Morricana, Bosco Martese — Lucio De Marcellis, Wikimedia Commons, CC BY-SA 3.0";
